import m from "../../../../geodata/es2015/region/world/africaLow";
window.am4geodata_region_world_africaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/africaLow.js
// module id = null
// module chunks = 